
// Also can pass in optional settings block
var rellax = new Rellax('.rellax');
